import { VALIDATE_DELEGATES, RESET_DELEGATES } from "./types";
import InterconexionService from "app/@Base/services/interconexion.service";

export function postDelegado(params) {
  return function (dispatch) {
    try {
      return InterconexionService.reqDelegado(params).then((data) => {
        dispatch({
          type: VALIDATE_DELEGATES,
          payload: data.indicador,
        });
      });
    } catch (error) {
      return (dispatch) => {
        dispatch({
          type: VALIDATE_DELEGATES,
          payload: false,
        });
      };
    }
  };
}

export function resetDelegado() {
  return function (dispatch) {
    dispatch({
      type: RESET_DELEGATES,
      payload: false,
    });
  };
}
